<template>
    <LoadingProductsSlider v-if="isLoading" class="mt-7"/>
    <section v-else-if="list && list.length >0" class="w-full mt-5 md:mt-9 lg:mt-10 xl:mt-11">
        <div class="flex items-center justify-between">
            <!-- store section title -->
            <StoreSectionTitle :title="$t('general.exclusive_offers_for_store')" class="mb-3" />
            <!-- more link -->
            <NuxtLink :to="exclusiveOffersLink" class="text-primaryLighter group cursor-pointer hover:brightness-125 whitespace-nowrap duration-150 transition-colors font-bold text-[0.8rem] xs:text-[0.9rem] md:text-[1rem] lg:text-[1.04rem] flex flex-nowrap gap-0.5 md:gap-1 items-center">
                <span>{{ $t('general.show_more')}}</span>
            </NuxtLink>
        </div>
        <!-- product offers list -->
        <ItemsSlider gap="1.5" wrapperTagType="ul" paddingTop="3">
            <OfferProductItem class="w-full" v-for="(product, index) in list" :key="product?.id || index" :item="product" @saveProductCardPosition="handleSaveProductCardPosition" />
        </ItemsSlider>
    </section>
</template>

<script>
import { ItemsSlider } from "@/components";
import { ROUTESNAMES } from "@/helpers";
import OfferProductItem from  "@/components/user/productItemDesigns/OfferProductItem.vue";

import LoadingProductsSlider from  "@/components/loadingSections/ProductsSlider.vue";
import StoreSectionTitle from "./StoreSectionTitle.vue";

export default {
    data(){
        return {
            ROUTESNAMES
        }
    },
    components: {
        ItemsSlider,
        OfferProductItem,
        StoreSectionTitle,
        LoadingProductsSlider
    },
    props: {
        isLoading: {
            type: Boolean,
            required: true,
            default: true
        },
        list: {
            type: Array,
            required: true,
            default: () => ([])
        },
        storeId: {
            type: [Number, String],
            required: true,
            default: ""
        }
    },
    computed: {
        exclusiveOffersLink(){
            return `${ROUTESNAMES.user.exclusiveOffers}/${this.storeId}`;
        }
    },
    methods: {
        handleSaveProductCardPosition(productId) {
            // Forward the event to parent (store page) only if productId is valid
            if (productId) {
                this.$emit('saveExclusiveOfferPosition', productId);
            }
        }
    }
}
</script>

<style></style>